<template>
  <v-dialog
    v-model="dialog"
    persistent
    :fullscreen="$vuetify.breakpoint.mobile"
    max-width="550"
    transition="dialog-bottom-transition"
    :content-class="$vuetify.breakpoint.mobile ? '' : 'dialog-rounded'"
    :scrollable="true"
  >
    <card-modal>
      <template v-slot:header>
        <span
          class="title-modal-card"
          :class="{ 'title-modal-ml': $vuetify.breakpoint.lgAndUp }"
          v-text="$t('checkout.guest_info')"
        />
        <v-spacer></v-spacer>
        <v-btn icon x-large @click="closeModal()">
          <v-icon x-large color="primary" v-text="'mdi-close'" />
        </v-btn>
      </template>
      <template v-slot:body>
        <v-card-subtitle
          class="mt-5 btn-text-login"
          :class="{ 'text-login-ml': $vuetify.breakpoint.lgAndUp }"
          @click="handlerLogin"
          v-text="$t('checkout.already_have_account')"
        />
        <v-form
          ref="Form"
          v-model="valid"
          :disabled="$store.getters.isLoading"
          class="test_yellow mt-1"
        >
          <v-row no-gutters justify="space-between">
            <v-col cols="12" md="6" class="px-3 test_purple">
              <v-text-field
                v-model="form.firstName"
                :label="$t('inputs.first_name')"
                clearable
                :rules="[$rules.required]"
              />
            </v-col>
            <v-col cols="12" md="6" class="px-3 test_purple">
              <v-text-field
                v-model="form.lastName"
                :label="$t('inputs.last_name')"
                clearable
                :rules="[$rules.required]"
              />
            </v-col>
            <v-col cols="12" md="6" class="px-3 test_purple">
              <v-text-field
                v-model="form.email"
                :label="$t('inputs.email')"
                clearable
                type="email"
                inputmode="email"
                :rules="[$rules.required, $rules.email]"
              />
            </v-col>
            <v-col cols="12" md="6" class="px-3 test_purple">
              <vue-tel-input-vuetify
                v-model="form.phoneNumber"
                :label="$t('inputs.phone_number')"
                clearable
                default-country="DK"
                type="tel"
                :input-options="{
                  showDialCode: true,
                  tabindex: 0,
                }"
                mode="international"
                :rules="[$rules.required, $rules.phoneNumber(phoneValid)]"
                :valid-characters-only="true"
                @input="onInputPhone"
              />
            </v-col>
          </v-row>
        </v-form>
      </template>
      <template v-slot:actions>
        <v-col>
          <ButtonSuccess :valid="valid" @click="save()" />
        </v-col>
        <v-col v-if="showDelete">
          <ButtonCancel title="general.delete" @click="remove()" />
        </v-col>
      </template>
    </card-modal>
  </v-dialog>
</template>
<script>
export default {
  name: "ModalGuestInfo",
  props: {
    dialog: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    valid: false,
    form: new Form({
      firstName: null,
      lastName: null,
      email: null,
      phoneNumber: null,
    }),
    phoneValid: false,
  }),
  computed: {
    showDelete: {
      get() {
        if (this.$store.getters.guestInfo) {
          return true;
        } else {
          return false;
        }
      },
      set(val) {
        return val;
      },
    },
  },
  watch: {
    "form.firstName": function (newValue) {
      this.form.firstName = this.$appCapitalizeLetter.first(newValue);
    },
    "form.lastName": function (newValue) {
      this.form.lastName = this.$appCapitalizeLetter.first(newValue);
    },
    "form.email": function (v) {
      if (v) {
        this.form.email = v.toLowerCase().trim();
      }
    },
  },
  mounted() {
    if (this.$store.getters.guestInfo) {
      this.form.keys().forEach((key) => {
        this.form[key] = this.$store.getters.guestInfo[key];
      });
    }
  },

  methods: {
    save: function () {
      const self = this;
      self.$store.dispatch("loading/start");
      self.form.phoneNumber = self.form.phoneNumber.replace(/\s/g, "");
      self.$store.dispatch("guest/setInfo", self.form);
      self.$store.dispatch("loading/done");
      self.closeModal();
    },
    remove: function () {
      const self = this;
      self.$store.dispatch("loading/start");
      self.$refs.Form.reset();
      self.$store.dispatch("guest/removeInfo");
      self.$store.dispatch("loading/done");
    },
    closeModal: function () {
      this.$emit("input", false);
    },
    onInputPhone(formattedNumber, { valid }) {
      this.phoneValid = valid;
    },
    handlerLogin() {
      this.$emit("handlerLogin");
    },
  },
};
</script>
<style lang="scss">
.centered-input input {
  text-align: center;
  font-size: 1.5rem;
}
.dialog-rounded {
  border-radius: 30px;
}
.centered-input.v-text-field--outlined .v-input__append-outer,
.centered-input.v-text-field--outlined .v-input__prepend-outer {
  margin-top: 13px;
}
.card-content {
  overflow-y: scroll !important;
}
</style>
<style lang="scss" scoped>
.details-title-bar {
  font-size: 1.6rem !important;
  font-weight: 700 !important;
}

.details-title {
  font-size: 2.5rem !important;
  font-weight: 800 !important;
}
.btn-text {
  font-size: 1.2rem !important;
  text-transform: none !important;
}
.btn-text-login {
  font-size: 1.2rem !important;
  cursor: pointer;
}
.text-login-ml {
  margin-left: -4px;
}
.title-modal-ml {
  margin-left: 15px;
}
.details-price {
  color: var(--v-primary-base) !important;
  font-size: 1.4rem !important;
  font-weight: 600;
}
.details-description {
  font-size: 1rem !important;
  padding-top: 0.2rem;
}
.list-item {
  background-color: white;
  border: solid;
  border-color: rgba(56, 56, 56, 0.2);
  border-width: 0.5px !important;
  border-radius: 5px;
}
.list-header-title {
  font-size: 1.2rem;
  color: black;
  font-weight: 800;
}
.list-text-title {
  font-size: 1.2rem;
}
.list-text-subtitle {
  font-size: 1rem;
}

.remove-efect-height {
  min-height: 0 !important;
}

.list-text-change {
  font-size: 0.9rem;
  color: var(--v-primary-base);
  font-weight: 700;
}

.btn-text {
  text-transform: none;
  font-size: 1.5rem;
}
</style>
